<template>
    <div class="sub-table p-2">
        <div class="dict-table-toolbar d-flex align-items-center gap-2 mb-3">
            <button type="button" class="btn action-btn action-btn--success"
                @click="this.$emit('open-dialog', this.id, false, null, 'DET')">
                <i class="bi bi-plus-lg"></i>
                <span>Təzə yazı</span>
            </button>
            <button type="button" class="btn action-btn action-btn--muted" @click="GetComplaintDet">
                <i class="bi bi-arrow-clockwise"></i>
                <span>Yeniləmək</span>
            </button>
        </div>

        <el-table border :data="dataTable" v-loading="loading">
            <el-table-column width="43">
                <template #default="scope">
                    <el-button class="edit-btn" @click="this.$emit('open-dialog', this.id, true, scope.row, 'DET')"
                        style="color: #4db2e5; padding: 0 !important;" :icon="Edit" text />
                </template>
            </el-table-column>
            <el-table-column label="Şikayət" prop="complaintName" />
            <el-table-column label="Diaqnoz" width="85">
                <template #default="scope">
                    <div style="text-align: center;">
                        <i v-if="scope.row.isDiaq == true" style="font-size: 18px;" class="bi bi-check-lg text-excel"></i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="43">
                <template #default="scope">
                    <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start" title="Info"
                        trigger="hover">
                        <template #reference>
                            <el-button type="default"  style="padding: 0 !important;" :icon="InfoFilled"  text />
                        </template>
                        <template #default>
                            <div>
                                Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {{ scope.row.created }} <br> Düzəliş olunub &nbsp;&nbsp;&nbsp;
                                {{ scope.row.updated }}
                            </div>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column width="43">
                <template #default="scope">
                    <el-button type="danger"  style="padding: 0 !important;" :icon="Delete"  class="edit-btn" @click="DeleteItem(scope.row)" text />
                </template>
            </el-table-column>
        </el-table>
        <br>
    </div>
</template>
<script>
import {
    Delete,
    Edit,
    InfoFilled
} from "@element-plus/icons-vue";

export default {
    props: {
        id: Number,
        refindex: Number,
        constindex: Number,
        type: String
    },
    data() {
        return {
            dataTable: null,
            alert: false,
            Edit,
            Delete,
            InfoFilled,
            loading: null
        }
    },
    methods: {
        GetComplaintDet() {
            
           //None
        },
        async DeleteItem() {
             //None
        }
    },
    watch: {
        refindex() {
            if (this.id == this.constindex) {
                this.GetComplaintDet()
            }
        }
    },
    mounted() {
        this.GetComplaintDet()
    }
}
</script>